var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-2",attrs:{"id":"faq"}},[_c('div',{staticClass:"py-2"},_vm._l((_vm.faqList),function(faqItem,i){return _c('FaqItem',{key:i,attrs:{"faqItem":faqItem}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }